import React from 'react'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="16"
      fill="none"
      viewBox="0 0 20 16"
    >
      <path
        stroke="#49E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.333"
        d="M13.333 4L6 11.333 2.667 8"
      />
      <path
        stroke="#49E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.333"
        d="M17.333 4L10 11.333 6.667 8"
      />
    </svg>
  )
}

export default Icon
